<template>
  <div class="translate-subtitle-page">
    <!-- Hero区域 -->
    <SubtitleHeroSection />

    <!-- 字幕翻译功能区域 -->
    <section class="translation-section">
      <div class="section-container">
        <CategoryTranslationForm
          category="subtitle"
          @start-translation="handleStartTranslation"
        />
      </div>
    </section>

    <!-- SEO内容区域 -->
    <SubtitleSeoContent />
  </div>
</template>

<script setup lang="ts">
// 导入字幕相关组件
import SubtitleHeroSection from '~/components/subtitle/SubtitleHeroSection.vue'
import SubtitleSeoContent from '~/components/subtitle/SubtitleSeoContent.vue'
import CategoryTranslationForm from '~/components/shared/CategoryTranslationForm.vue'

// 设置页面标题和meta信息
const { t } = useI18n()
useWebsiteSeo({
  title: () => t('seo.category.subtitle.title'),
  description: () => t('seo.category.subtitle.desc')
})

// 处理翻译请求
const handleStartTranslation = (settings: any) => {
  console.log('字幕翻译页面接收到翻译请求:', settings)
  // TODO: 第二阶段实现实际翻译功能
}
</script>

<style scoped lang="scss">
.translate-subtitle-page {
  min-height: 100vh;
  background: $gray-50;
}

.translation-section {
  padding: $spacing-xxl 0;
  background: linear-gradient(135deg,
    rgba(#8B5CF6, 0.05) 0%,
    rgba(#4A90E2, 0.05) 50%,
    rgba(#059669, 0.03) 100%);

  .section-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 $spacing-lg;
  }
}

@media (max-width: 768px) {
  .translation-section {
    padding: $spacing-xl 0;

    .section-container {
      padding: 0 $spacing-md;
    }
  }
}
</style>
